import { BearerTokenContext } from "core/context/BearerTokenContext";
import { useContext } from "react";

export function useBearerToken(): string | undefined {
  return useContext(BearerTokenContext);
}
